module.exports = __webpack_public_path__ + "img/boat.4e442f9b.svg";